import React, { RefObject, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNotification, useTranslate } from "@refinedev/core";

import { Modal, ModalRef } from "@shared/components";
import { PlanFormProduct } from "@modules/defaultProducts/components/ProductPlans/PlanFormProduct";
import { masks } from "@core/utils/masks";
import { api } from "@api/api";

type CreateAgreementProductPlanModalProps = {
  modalRef: RefObject<ModalRef>;
  agreementId?: number | string | null;
  productId?: number | null;
  onComplete?: () => void;
};

export function CreateAgreementProductPlanModal({ modalRef, agreementId, productId, onComplete }: CreateAgreementProductPlanModalProps) {
  const translate = useTranslate();
  const { open } = useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const methods = useForm<any>({
    defaultValues: {
      name: "",
      description: "",
      value: "",
      level: 0,
      vindi_page: "",
      vindi_token: "",
    },
    mode: "onBlur",
  });

  const handleConfirm = async () => {
    try {
      setIsLoading(true);
      const values = methods.getValues();

      const payload = {
        name: values.name,
        description: values.description,
        value: values.value ? String(Number(masks.unmask(values.value)) / 100) : "0",
        level: values.level,
        vindi_page: values.vindi_page,
        vindi_token: values.vindi_token,
        agreement: typeof agreementId === 'string' ? parseInt(agreementId) : agreementId,
        product: productId,
      };

      await api.post(`v1/subscription_plan_admin/`, payload);

      open?.({
        type: "success",
        message: translate("subscription_plan_admin.success.create"),
      });

      onComplete?.();
      modalRef.current?.close();
    } catch (error) {
      console.error('Error creating agreement product plan:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      ref={modalRef}
      title={translate("subscription_plan_admin.titles.create")}
      onConfirm={handleConfirm}
      methods={methods}
      isPending={isLoading}
    >
      <FormProvider {...methods}>
        <PlanFormProduct productId={!!productId} />
      </FormProvider>
    </Modal>
  );
}


